import React from "react";
import { MenuItem, Button } from "@blueprintjs/core";
import { Select, ItemPredicate, ItemRenderer } from "@blueprintjs/select";
import { Company } from "types";
import { ApolloError } from "@apollo/client";

type Props = {
    companies: Company[];
    selectedCompany: Company | undefined;
    loading: boolean;
    error: ApolloError | undefined;
    onCompanySelect: (c: Company) => void;
    editing?: boolean;
};

export default function CompanySelect({ companies, selectedCompany, loading, error, onCompanySelect, editing }: Props) {
    return (
        <Selector
            itemPredicate={filterCompany}
            itemRenderer={renderCompany}
            items={companies ? companies : []}
            activeItem={selectedCompany}
            onItemSelect={(c) => {
                onCompanySelect(c);
            }}
            disabled={!!error || editing}
            noResults={<MenuItem disabled={true} text="No results." />}
            popoverProps={{ minimal: true, popoverClassName: "custom-select" }}
        >
            <Button
                icon="office"
                rightIcon="caret-down"
                text={selectedCompany?.name ? `${selectedCompany.name}` : "Select a Company"}
                loading={loading}
                disabled={!!error || editing}
            />
        </Selector>
    );
}

const Selector = Select.ofType<Company>();

const filterCompany: ItemPredicate<Company> = (query, company) => {
    return company.name.toLowerCase().indexOf(query.toLowerCase()) >= 0;
};

const renderCompany: ItemRenderer<Company> = (company, { handleClick, modifiers }) => {
    if (!modifiers.matchesPredicate) {
        return null;
    }
    return (
        <MenuItem active={modifiers.active} key={company.id} onClick={handleClick} text={company.name} icon="office" />
    );
};
